module.exports = __webpack_public_path__ + "static/assets/8be3f8091b60cc37c863b2d0b049ba85.svg";